import moment from "moment-timezone";
import {format} from "date-fns";

export const formatedDateTime = (datetime: string) => {
    try {
        const date = new Date(datetime);
        return format(date, "MMMM d, h:mm a")
    } catch (e) {
        return ""
    }
}

export const formatedDate = (datetime: string) => {
    try {
        const date = new Date(datetime);
        return format(date, "EEEE, MMMM d yyyy")
    } catch (e) {
        return ""
    }
}

export const formatedTime = (datetime: string) => {
    const date = new Date(datetime);
    return format(date, "h:mm a")
}

export const extractUtcOffset = (text: string): string => {
    const match = text.match(/\(UTC([+-]?\d{2}:\d{2})?\)/);
    if (match) {
        return match[1] || "00:00";
    }
    return "00:00";
};

/**
 * Formats a date to show in a different time zone based on the provided offset.
 *
 * @param datetime - The date string in ISO format.
 * @param offset - The time zone offset (e.g., "-05:00").
 * @param formatString - The format string to use for formatting the date (e.g., "dddd, MMMM D YYYY").
 * @returns The formatted date string.
 */
export const formatedDateTimeOffsetUtc = (datetime: string, offset: string, formatString: string = "dddd, MMMM D YYYY [at] h:mm A"): string => {
    try {
        // Parse the date string and apply the offset
        const date = moment(datetime).utcOffset(offset);

        // Format the date in the desired format
        return date.format(formatString);
    } catch (e) {
        return "";
    }
};

// Utility: format ms into mm:ss
export const formatTime = (timeMs: number): string => {
  const minutes = Math.floor(timeMs / (1000 * 60))
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor((timeMs / 1000) % 60)
    .toString()
    .padStart(2, "0");

  return `${minutes}:${seconds}`;
};

